<template>
	<div class="w1200">
			<div class="association-brief-box">
				<div class="crumbs">
					<span>首页 ></span>
					<span><a href="#">章程公示</a></span>
				</div>
				<div class="article-box w1000">
					<h2>北京（市）建筑设施服务企业协会章程</h2>
					<p class="hd">第一章 总则</p>
					<p>第一条 本团体（或本会）定名为：北京（市）建筑设施服务企业协会（以下简称本团体或本会），英文名称 Beijing Building Service Contractors Association，缩写 BBSCA。</p>
					<p>第二条 本团体依照《社会团体登记管理条例》的规定，由北京地区服务于建筑物的环境科技企业、设施服务企业、空气检测企业、节能环保企业等自愿联合发起成立，是经北京市社会团体登记管理机关核准登记的非营利性社会团体。</p>
					<p>第三条 本团体的宗旨是：遵守宪法、法律、法规和国家政策，践行社会主义核心价值观，遵守社会道德风尚。团结所有商业地产、公共建筑等企业、机构，制定国家标准、行业标准、规范行业行为、提供专业技能培训、培育行业企业的社会责任，充分发挥协会的桥梁、纽带和参谋作用，促进本协会成为全国同行业的领军协会。</p>
					<p>第四条 本团体根据《中国共产党章程》的规定，设立中国共产党的组织，开展党的活动，为党组织的活动提供必要条件。暂不具备单独建立党组织条件的，可以通过建立联合党组织或由上级党组织选派党建工作指导员等方式，指导开展党的工作。本会邀请党组织负责人参加或列席本会管理层会议。党组织对本会重要事项决策、重要业务活动、大额经费开支、接收大额捐赠、开展涉外活动等提出意见。 本团体的登记管理机关是北京市民政局。 本会接受登记管理机关、党建领导机关、有关行业管理部门的业务指导和监督管理。
					</p>
					<p>第五条 本团体的办公住所：北京市西城区右安门内西街甲10号院四层。</p>
					<p class="hd">第二章 业务范围</p>
					<p class="p01">第六条 本团体的业务范围：</p>
					<p class="p02">
						（一） 承接课题研讨，开展理论研究，接受委托、调查研究进行论证以及学术研究、举办论坛及展览；</p>
					<p class="p02">
						（二）举办专业技能培训，组织会员进行各种学习、考察和调研活动，发挥会员的积极性，组织、宣传、提升从业人员的素质，提高服务质量；</p>
					<p class="p02">
						（三）规范行业行为，制定行业规范、制定行业标准，协调同行价格争议，维护公平竞争；推动行业产品结构的调整，组织新产品上市，开展行业创新品牌活动；</p>
					<p class="p02">
						（四）接受会员单位的委托，担任会员单位合法权益的维护人，维护会员合法权益；</p>
					<p class="p02">
						（五）组织相关的专业委员会，推动横向经济联合，组织展览、专业会议、展销、理论研讨，加快行业发展；</p>
					<p class="p02">
						（六）编印会刊，积极与国内外商协会合作，资源共享，共同做好协会向公众宣传工作；</p>
					<p class="p02">
						（七）充分利用行业协会的各种资源优势，承办各级政府和有关部门委托的事项；</p>
					<p class="p02">
						（八）发展本行业公益事业，提升企业的社会责任感。</p>

					<p class="hd">第三章 会员</p>
					<p>第七条 本团体由个人会员（或单位会员、或个人会员和单位会员）组成。</p>
					<p class="p02">
						（一） 承接课题研讨，开展理论研究，接受委托、调查研究进行论证以及学术研究、举办论坛及展览；</p>
					<p class="p01">第八条 申请加入本团体的会员，必须具备下列条件：</p>
					<p class="p02">（一）拥护本团体的章程；</p>
					<p class="p02">（二）有加入本团体的意愿；</p>
					<p class="p02">（三）在本团体的业务（行业、学科）领域内具有一定的影响；</p>
					<p class="p01">第九条 会员入会的程序是：</p>
					<p class="p02">（一）提交入会申请书；</p>
					<p class="p02">（二）经理事会讨论通过；</p>
					<p class="p02">（三）由理事会（理事会授权的机构）发给会员证；</p>
					<p class="p01">第十条 会员享有下列权利：</p>
					<p class="p02">（一）本团体的选举权、被选举权和表决权；</p>
					<p class="p02">（二）参加本团体的活动权；</p>
					<p class="p02">（三）获得本团体服务的优先权；</p>
					<p class="p02">（四）对本团体工作的批评建议权和监督权；</p>
					<p class="p02">（五）入会自愿、退会自由；</p>
					<p class="p01">第十一条 会员履行下列义务:</p>
					<p class="p02">（一）执行本团体的决议；</p>
					<p class="p02">（二）维护本团体的合法权益和声誉；</p>
					<p class="p02">（三）完成本团体交办的工作；</p>
					<p class="p02">（四）按规定交纳会费；</p>
					<p class="p02">（五）向本团体反映情况，提供有关资料；</p>

					<p class="p01">第十二条 会员退会应书面通知本团体，并交回会员证。会员一年不交纳会费或不参加本团体活动，视为自动退会。</p>
					<p class="p01">第十三条 会员如有严重违反本章程的行为，经理事会（常务理事会）表决通过，予以除名。</p>

					<p class="hd">第四章 组织机构</p>

					<p class="p01">第十四条 本团体的最高权力机构是会员（代表）大会，其主要职责是：</p>
					<p class="p02">（一）制定和修改章程:</p>
					<p class="p02">（二）选举和罢免理事、监事:</p>
					<p class="p02">（三）审议理事会、监事会的工作报告和财务报告:</p>
					<p class="p02">（四）决定重大变更和终止事宜:</p>
					<p class="p02">（五）制定和修改会费标准:</p>
					<p class="p02">（六）决定其他重大事宜。</p>
					<p class="p01">第十五条 会员（代表）大会须有2/3以上的会员（或会员代表）出席方能召开，其决议须经到会会员（或会员代表）2/3以上表决通过方能生效。</p>
					<p class="p01">第十六条 会员（代表）大会每届x年（3-5年）。召开会员(或代表)大会30日前，应将会议准备材料送至社会团体登记管理机关审查，确认符合开会条件后方可召开。召开会员大会后将会议纪要及有关材料报社会团体登记管理机关，按规定办理成立登记手续。因特殊情况需提前或延期换届的，须由理事会表决通过，报社会团体登记管理机关批准同意。但延期换届最长不超过一年。</p>
					<p class="p01">第十七条 理事会在会员（代表）大会闭会期间执行会员（代表）大会的决议，领导本团体开展日常工作，对会员（代表）大会负责。</p>
					<p class="p01">第十八条 理事会的职责是：</p>
					<p class="p02">（一）执行会员（代表）大会的决议:</p>
					<p class="p02">（二）选举和罢免理事长（会长）、副理事长（副会长）、秘书长:</p>
					<p class="p02">（三）筹备召开会员（代表）大会:</p>
					<p class="p02">（四）向会员（代表）大会报告工作和财务状况:</p>
					<p class="p02">（五）决定会员的吸收或除名:</p>
					<p class="p02">（六）决定办事机构、分支机构、代表机构、实体机构的设立和办公住所的变更:</p>
					<p class="p02">（七）决定副秘书长、各机构主要负责人的聘任:</p>
					<p class="p02">（八）领导本团体各机构开展工作:</p>
					<p class="p02">（九）制定内部管理制度:</p>
					<p class="p02">（十）接受监事会提出的对本团体违纪问题的处理意见，提出解决办法并接受其监督;</p>
					<p class="p02">（十一）决定其他重大事项。</p>
					<p class="p01">第十九条 理事会须有2/3以上理事出席方能召开，其决议须经到会理事2/3以上表决通过方能生效。</p>
					<p class="p01">第二十条 理事会每年至少召开一次会议，情况特殊的也可采用通讯形式召开。
						<p class="p01">第二十一条 本团体设立常务理事会，常务理事不少于五人，但一般不超过理事总数的1/3，且为单数。常务理事从理事中选举产生。常务理事会在理事会闭会期间行使下列职权，并对理事会负责：</p>
						<p class="p02">（一）执行会员（代表）大会的决议:</p>
						<p class="p02">（二）筹备召开会员（代表）大会:</p>
						<p class="p02">（三）决定会员的吸收或除名:</p>
						<p class="p02">（四）决定办事机构、分支机构、代表机构、实体机构的设立和办公住所的变更:</p>
						<p class="p02">（五）决定副秘书长、各机构主要负责人的聘任:</p>
						<p class="p02">（六）领导本团体各机构开展工作:</p>
						<p class="p02">（七）制定内部管理制度:</p>
						<p class="p02">（八）接受监事会提出的对本团体违纪问题的处理意见，提出解决办法并接受其监督。</p>
						<p class="p02">常务理事会与理事会任期相同，与理事会同时换届。
							<p class="p01">第二十二条 常务理事会须有2/3以上常务理事出席方能召开，其决议须经到会常务理事2/3以上表决通过方能生效。</p>
							<p class="p01">第二十三条 常务理事会至少半年召开一次会议，情况特殊的也可采用通讯形式召开。</p>
							<p class="p01">第二十四条 本团体的理事长（会长）、副理事长（副会长）、秘书长必须具备下列条件：</p>
							<p class="p02">（一）坚持党的路线、方针、政策，政治素质好:</p>
							<p class="p02">（二）在本团体业务领域内有较大影响:</p>
							<p class="p02">（三）最高任职年龄不超过70周岁，秘书长为专职:</p>
							<p class="p02">（四）身体健康，能坚持正常工作:</p>
							<p class="p02">（五）未受过剥夺政治权利的刑事处罚:</p>
							<p class="p02">（六）具有完全民事行为能力:</p>
							<p class="p01">第二十五条 本团体的法定代表人为理事长（会长）。</p>
							<p class="p02">本团体的法定代表人不得同时担任其他社会团体的法定代表人。</p>
							<p class="p02">理事长（会长）任期不超过两届。</p>
							<p class="p01">第二十六条 本团体理事长（会长）行使下列职权：
								<p class="p02">（一）召集和主持理事会（或常务理事会）:</p>
								<p class="p02">（二）检查会员（代表）大会、理事会（或常务理事会）决议的落实情况:</p>
								<p class="p02">（三）代表本团体签署有关重要文件:</p>
								<p class="p01">第二十七条 本团体常务副理事长（常务副会长）行使下列职权：</p>
								<p class="p02">（一）协助理事长（会长）工作</p>
								<p class="p02">（二）代表本团体签署有关重要文件。</p>
								<p class="p01">第二十八条 本团体秘书长行使下列职权：</p>
								<p class="p02">（一）主持办事机构开展日常工作，组织实施年度工作计划:</p>
								<p class="p02">（二）协调各分支机构、代表机构、实体机构开展工作:</p>
								<p class="p02">（三）提名副秘书长以及各办事机构、分支机构、代表机构和实体机构主要负责人，交理事会或常务理事会决定:</p>
								<p class="p02">（四）决定办事机构、代表机构、实体机构专职工作人员的聘用:</p>
								<p class="p02">（五）代表本团体签署有关重要文件:</p>（秘书长担任法定代表人的适用此条）。</p>
							<p class="p02">（六）处理其他日常事务。</p>
							<p class="p01">第二十九条 本团体设监事会，由三人组成（应为单数），由会员（代表）大会选举产生，向会员（代表）大会负责。其主要职责是：</p>
							<p class="p02">（一）选举产生监事长:</p>
							<p class="p02">（二）出席理事会（或常务理事会）:</p>
							<p class="p02">（三）监督本团体及领导成员依照《社会团体登记管理条例》和有关法律、法规开展活动:</p>
							<p class="p02">（四）督促本团体及领导成员依照核定的章程、业务范围及内部管理制度开展活动:</p>
							<p class="p02">（五）对本团体成员违反本团体纪律，损害本团体声誉的行为进行监督:</p>
							<p class="p02">（六）对本团体的财务状况进行监督:</p>
							<p class="p02">（七）对本团体的违法违纪行为提出处理意见，提交理事会（或常务理事会）并监督其执行。</p>

							<p class="hd">第五章 资产管理</p>
							<p class="p01">第三十条 本团体经费来源：</p>
							<p class="p02">（一）会费；</p>
							<p class="p02">（二）捐赠；</p>
							<p class="p02">（三）政府资助；</p>
							<p class="p02">（四）在核准的业务范围内开展活动或服务的收入；</p>
							<p class="p02">（五）利息；</p>
							<p class="p02">（六）其他合法收入。</p>
							<p class="p01">第三十一条 本团体按照国家有关规定收取会员会费。制定或者修改会费标准，应当召开会员（代表）大会，应当有2/3以上会员（会员代表）出席，并经出席会员（会员代表）1/2以上表决通过，表决采取无记名投票方式进行。</p>
							<p class="p01">第三十二条 本团体经费必须用于本章程规定的业务范围和事业的发展，不得在会员中分配。</p>
							<p class="p01">第三十三条 本团体建立严格的财务管理制度，保证会计资料合法、真实、准确、完整。</p>
							<p class="p01">第三十四条 本团体配备具有专业资格的会计人员。会计不得兼任出纳。会计人员必须进行会计核算，实行会计监督。会计人员调动工作或离职时，必须与接管人员办清交接手续。</p>
							<p class="p01">第三十五条 本团体的资产管理执行国家规定的财务管理制度，接受会员（代表）大会和有关部门的监督。资产来源属于政府拨款或者社会捐赠、资助的，必须接收审计机关的监督，并将有关情况以适当方式向社会公布。</p>
							<p class="p01">第三十六条 本团体换届或更换法定代表人之前必须接受社会团体登记管理机关组织的财务审计。</p>
							<p class="p01">第三十七条 本团体的资产任何单位、个人不得侵占、私分和挪用。</p>
							<p class="p01">第三十八条 本团体专职工作人员的工资和保险、福利待遇，参照国家对事业单位的有关规定执行。</p>

							<p class="hd">第六章 终止程序</p>
							<p class="p01">第三十九条 本团体完成宗旨、自行解散或由于分立、合并等原因需要注销的，由理事会或常务理事会提出终止动议。</p>
							<p class="p01">第四十条 本团体终止动议须经会员（代表）大会表决通过，并报社会团体登记管理机关审查同意。</p>
							<p class="p01">第四十一条 本团体终止前，须在社会团体登记管理机关及有关机关指导下成立清算组织，清理债权债务，处理善后事宜。清算期间，不得开展清算以外的活动。</p>
							<p class="p01">第四十二条 本团体经社会团体登记管理机关办理注销登记手续后即为终止。</p>
							<p class="p01">第四十三条 本团体终止后的剩余财产，在社会团体登记管理机关的监督下，按照国家有关规定，用于发展与本团体宗旨相关的事业</p>

							<p class="hd">第七章 附则</p>
							<p class="p01">第四十四条 本章程经2018年8月15日会员（代表）大会表决通过。</p>
							<p class="p01">第四十五条 本章程的解释权属本团体的理事会。</p>
							<p class="p01">第四十六条 本章程自社会团体登记管理机关核准之日起生效。</p>

				</div>
			</div>

		</div>

		
</template>

<script>
	import Vue from 'vue';
	export default {

		data() {
			return {}
		},
		methods: {

		},
		components: {}
	}
</script>

<style>

	@import "../assets/css/detail.css";
</style>


// WEBPACK FOOTER //
// src/components/Constitution.vue